import 'init/1-polyfills';
import 'init/2-containerWeb';
import 'init/3-prelude';
import 'init/4-i18next';
import { createReactContainerAndRunStore } from 'src/lib/createReactContainerAndRunStore';
import { localWorkspaceServiceModule } from 'src/services/WorkspaceService/localWorkspaceServiceModule';
import { container } from 'src/StaticContainer';
import { launchDarklyBrowserModule } from 'src/store/modules/launchDarklyBrowserModule';
import { localStoreModule } from 'src/store/modules/localStoreModule';

container.load(launchDarklyBrowserModule);
window.reactContainer = createReactContainerAndRunStore(localStoreModule, localWorkspaceServiceModule);
